<template>
    <div class="recording-indicator" :class="{ 'with-messages': hasConnection }">
        <div class="pulse"></div>
        
    </div>
</template>

<script>
export default {
    name: 'RecordingIndicator',
    props: {
        hasConnection: Boolean
    }
};
</script>

<style scoped>
.recording-indicator {
    display: flex;
    align-items: center;
    gap: 10px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding: 16px 16px;
    background-color: var(--container-color);
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 100;
}

.pulse {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #d63031;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(214, 48, 49, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(214, 48, 49, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(214, 48, 49, 0);
    }
}
</style>